import filter from 'lodash/filter'
import groupBy from 'lodash/groupBy'
import { useMemo } from 'react'
import { calculateAvgPrice, parseData, stripQuarters } from './helperFunctions'
import type { ScatterPlotGraphData } from './typings'
import { useRegressionLineForData } from './useRegressionLineForData'

export const useDataForScatterPlotGraph = (
  region: string,
  data: ScatterPlotGraphData[],
  jsonKey: 'kauf' | 'miete'
) => {
  const { avg_prices_per_year_neubau, avg_prices_per_year_bestand } =
    useMemo(() => {
      const filteredForRegion = filter(data, (d) => d.name === region)
      const strippedQuarters = stripQuarters(filteredForRegion)

      const filteredForRegion_neubau = strippedQuarters.map((d: any) => {
        return {
          avg_price: d[`mittl_preis_qm_${jsonKey}_neubau`],
          type: 'Neubau',
          name: d['name'],
          zeit: d['zeit'],
        }
      })
      const filteredForRegion_bestand = strippedQuarters.map((d: any) => {
        return {
          avg_price: d[`mittl_preis_qm_${jsonKey}_bestand`],
          type: 'Bestand',
          name: d['name'],
          zeit: d['zeit'],
        }
      })

      const groupedByYear_neubau = groupBy(filteredForRegion_neubau, 'zeit')
      const groupedByYear_bestand = groupBy(filteredForRegion_bestand, 'zeit')

      const avg_prices_per_year_neubau = calculateAvgPrice(groupedByYear_neubau)
      const avg_prices_per_year_bestand = calculateAvgPrice(
        groupedByYear_bestand
      )

      return { avg_prices_per_year_neubau, avg_prices_per_year_bestand }
    }, [data, jsonKey, region])

  const finalData_neubau = parseData(avg_prices_per_year_neubau)
  const finalData_bestand = parseData(avg_prices_per_year_bestand)

  const regressionLineValues_neubau = useRegressionLineForData(
    'y',
    finalData_neubau
  )
  const regressionLineValues_bestand = useRegressionLineForData(
    'y',
    finalData_bestand
  )

  return {
    finalData_neubau,
    finalData_bestand,
    regressionLineValues_neubau,
    regressionLineValues_bestand,
  }
}
